var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"caption grey--text font-weight-light"},[_vm._v(_vm._s(_vm.brand))])}
var staticRenderFns = []

export { render, staticRenderFns }